var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5927_2704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.625 8.49333V5.83333C23.625 4.55 22.6125 3.5 21.375 3.5H5.625C4.37625 3.5 3.375 4.55 3.375 5.83333V22.1667C3.375 23.45 4.37625 24.5 5.625 24.5H21.375C22.6125 24.5 23.625 23.45 23.625 22.1667V19.5067C24.2887 19.0983 24.75 18.3633 24.75 17.5V10.5C24.75 9.63667 24.2887 8.90167 23.625 8.49333ZM22.5 10.5V17.5H14.625V10.5H22.5ZM5.625 22.1667V5.83333H21.375V8.16667H14.625C13.3875 8.16667 12.375 9.21667 12.375 10.5V17.5C12.375 18.7833 13.3875 19.8333 14.625 19.8333H21.375V22.1667H5.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15.75C18.932 15.75 19.6875 14.9665 19.6875 14C19.6875 13.0335 18.932 12.25 18 12.25C17.068 12.25 16.3125 13.0335 16.3125 14C16.3125 14.9665 17.068 15.75 18 15.75Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5927_2704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 28,
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.1ea6371ae7493626d3795b3435b0ff30.svg";
export { ForwardRef as ReactComponent };